<div class="container-fluid" style="padding:0">
    <div class="row">
        <div class="col-lg-2">
            <app-navbar></app-navbar>
        </div>
        <div class="col-lg-10">
            <div class="row">
                <div class="col-lg-9">
                    <br>
                    <h2>Reporte Ventas</h2>
                </div>
                <div class="col-lg-2">
                    
                </div>
            </div>

            <div class="row">
                <div class="col-lg-3">
                    <span class="bold">Fecha Inicio</span>
                    <div class="input-group">
                        <input id="fecha_inicio" class="form-control"  [(ngModel)]="formulario.fecha_inicio" placeholder="Fecha Inicio yyyy-mm-dd" name="dp1b" ngbDatepicker #dp1b="ngbDatepicker">
                        <div class="input-group-append">
                        <button class="btn btn-outline-secondary calendar" (click)="dp1b.toggle()" type="button">
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-calendar-date" viewBox="0 0 16 16">
                            <path d="M6.445 11.688V6.354h-.633A12.6 12.6 0 0 0 4.5 7.16v.695c.375-.257.969-.62 1.258-.777h.012v4.61h.675zm1.188-1.305c.047.64.594 1.406 1.703 1.406 1.258 0 2-1.066 2-2.871 0-1.934-.781-2.668-1.953-2.668-.926 0-1.797.672-1.797 1.809 0 1.16.824 1.77 1.676 1.77.746 0 1.23-.376 1.383-.79h.027c-.004 1.316-.461 2.164-1.305 2.164-.664 0-1.008-.45-1.05-.82h-.684zm2.953-2.317c0 .696-.559 1.18-1.184 1.18-.601 0-1.144-.383-1.144-1.2 0-.823.582-1.21 1.168-1.21.633 0 1.16.398 1.16 1.23z"/>
                            <path d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5zM1 4v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4H1z"/>
                            </svg>
                        </button>
                        </div>
                    </div>
                </div>

                <div class="col-lg-3">
                    <span class="bold">Fecha Fin</span>
                    <div class="input-group">
                        <input id="fecha_fin" class="form-control"  [(ngModel)]="formulario.fecha_fin" placeholder="Fecha Fin yyyy-mm-dd" name="dp2b" ngbDatepicker #dp2b="ngbDatepicker">
                        <div class="input-group-append">
                        <button class="btn btn-outline-secondary calendar" (click)="dp2b.toggle()" type="button">
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-calendar-date" viewBox="0 0 16 16">
                            <path d="M6.445 11.688V6.354h-.633A12.6 12.6 0 0 0 4.5 7.16v.695c.375-.257.969-.62 1.258-.777h.012v4.61h.675zm1.188-1.305c.047.64.594 1.406 1.703 1.406 1.258 0 2-1.066 2-2.871 0-1.934-.781-2.668-1.953-2.668-.926 0-1.797.672-1.797 1.809 0 1.16.824 1.77 1.676 1.77.746 0 1.23-.376 1.383-.79h.027c-.004 1.316-.461 2.164-1.305 2.164-.664 0-1.008-.45-1.05-.82h-.684zm2.953-2.317c0 .696-.559 1.18-1.184 1.18-.601 0-1.144-.383-1.144-1.2 0-.823.582-1.21 1.168-1.21.633 0 1.16.398 1.16 1.23z"/>
                            <path d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5zM1 4v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4H1z"/>
                            </svg>
                        </button>
                        </div>
                    </div>
                </div>

                <div class="col-lg-3">
                    <span class="bold">Forma de pago:</span>
                    <select #formaPagoSelect class="form-control">
                        <option value="0">Seleccione forma de pago</option>
                        <option value="Efectivo">Efectivo</option>
                        <option value="Depósito Bancario">Depósito Bancario</option>
                        <option value="Transferencia Electrónica">Transferencia Electrónica</option>
                        <option value="Tarjeta de Crédito">Tarjeta de Crédito</option>
                        <option value="Tarjeta de Débito">Tarjeta de Débito</option>
                    </select>
                </div>

                <div class="col-lg-3">
                    <span class="bold">Tipo de pago:</span>
                    <select #tipoPagoSelect class="form-control">
                        <option value="0">Seleccione tipo de pago</option>
                        <option value="Cuadros">Cuadros</option>
                        <option value="Viaje">Viaje</option>
                        <option value="Fiesta">Fiesta</option>
                    </select>
                </div>

                <div class="col-lg-3">
                    Selecciona Grupo:
                    <select class="form-control"  #grupoSelect>
                        <option value="0">Seleccione Grupo</option>
                        <option *ngFor = "let grupo of grupos" [value]="grupo.id">{{grupo.nombre}}</option>
                    </select>
                    <br>
                </div>

                <div class="col-lg-3">
                    <br>
                    <button class="btn btn-success" (click)="getPagosGrupo(grupoSelect.value, formaPagoSelect.value, tipoPagoSelect.value)">Filtrar</button>
                </div>

                <div class="col-lg-3">
                    <br>
                    <button class="btn btn-success" (click)="descargarExcel(grupoSelect.value, formaPagoSelect.value, tipoPagoSelect.value)">Exportar a Excel</button>
                </div>

            </div>
            <div class="row">
                <div class="col-lg-3">
                    Total recaudado: {{totalPagado | currency}}<br><br>
                </div>
            </div>
            <div class="row">
                <div class="col-lg-10">
                    <table  class="table table-striped row-border hover">
                        <thead class="thead-dark">
                            <tr>
                                <td>ID</td>
                                <td>Fecha</td>
                                <td>Cliente</td>
                                <td>Monto</td>
                                <td>Forma Pago</td>
                                <td>Tipo de Pago</td>
                                <td>Registró</td>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let pago of pagos">
                                <td>{{pago.id}}</td>
                                <td>{{pago.fecha}}</td>
                                <td>{{pago.usuario}}</td>
                                <td>{{pago.monto |currency}}</td>
                                <td>{{pago.forma_pago}}</td>
                                <td>{{pago.tipo_pago}}</td>
                                <td>{{pago.registro}}</td>
                            </tr>
                        
                        </tbody>
                    </table>
                </div>
                
            </div>

            
        </div>
    </div>
</div>